export enum Tab {
  BET_SLIP = 'betSlip',
  MY_STAKES = 'myStakes',
}

export enum SidebarWidth {
  MIN = 302,
  MAX = 342,
}
